// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"d490fcf7","585":"ee68a568"}[chunkId] + ".chunk.js";
};